import http from '@/api/http';
import { Offer, OffersResponse, OfferViewResponse } from '../interfaces/offer.interface';
import { ToastService } from '@/services/toast.service';

export class OffersApi {
  private basePath = '/offers';

  async findAll(): Promise<OffersResponse> {
    try {
      const response = await http.get<any>(this.basePath);
      return response.data.data; // Extract data from wrapped response
    } catch (error: any) {
      ToastService.error(error);
      throw error;
    }
  }

  async viewOffer(id: number, direction?: string): Promise<OfferViewResponse> {
    try {
      const params = direction ? { direction } : undefined;
      const response = await http.get<any>(`${this.basePath}/${id}/view`, { params });
      return response.data.data; // Extract data from wrapped response
    } catch (error: any) {
      ToastService.error(error);
      throw error;
    }
  }
}

export const offersApi = new OffersApi();